import { render, staticRenderFns } from "./DaoshiList.vue?vue&type=template&id=3cf22c57&scoped=true&"
import script from "./DaoshiList.vue?vue&type=script&lang=js&"
export * from "./DaoshiList.vue?vue&type=script&lang=js&"
import style0 from "./DaoshiList.vue?vue&type=style&index=0&id=3cf22c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf22c57",
  null
  
)

export default component.exports